var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.449,7.795L13.997,2.62c-0.14-0.132-0.324-0.206-0.517-0.206H5.067c-0.414,0-0.75,0.336-0.75,0.75v17.707 c0,0.414,0.336,0.75,0.75,0.75h13.866c0.414,0,0.75-0.336,0.75-0.75V8.339C19.683,8.133,19.598,7.937,19.449,7.795z M17.638,8.144 h-3.957V4.388L17.638,8.144z M5.817,20.121V3.914h6.364v4.98c0,0.414,0.336,0.75,0.75,0.75h5.252v10.477H5.817z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.615,11.422H7.933c-0.221,0-0.4,0.179-0.4,0.4v2.41c0,0.221,0.179,0.4,0.4,0.4h0.682c0.885,0,1.605-0.721,1.605-1.605 S9.5,11.422,8.615,11.422z M8.615,13.831H8.333v-1.609h0.282c0.444,0,0.805,0.361,0.805,0.805 C9.42,13.471,9.059,13.831,8.615,13.831z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.017,11.422c-0.828,0-1.501,0.72-1.501,1.604s0.673,1.605,1.501,1.605s1.502-0.721,1.502-1.605 S12.845,11.422,12.017,11.422z M12.017,13.831c-0.387,0-0.702-0.36-0.702-0.805c0-0.443,0.315-0.805,0.702-0.805 s0.701,0.361,0.701,0.805C12.718,13.471,12.403,13.831,12.017,13.831z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.365,12.222c0.201,0,0.347,0.094,0.434,0.173c0.163,0.148,0.416,0.137,0.564-0.027c0.148-0.164,0.137-0.417-0.027-0.565 c-0.27-0.245-0.614-0.38-0.971-0.38c-0.828,0-1.502,0.72-1.502,1.604s0.674,1.605,1.502,1.605c0.34,0,0.659-0.118,0.926-0.341 c0.169-0.142,0.191-0.394,0.05-0.563c-0.143-0.171-0.395-0.191-0.563-0.05c-0.12,0.101-0.263,0.153-0.412,0.153 c-0.387,0-0.701-0.36-0.701-0.805C14.664,12.583,14.979,12.222,15.365,12.222z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.aad06893e5671ae3d63a7a25dc2f6220.svg";
export { ForwardRef as ReactComponent };